import { cn } from "@/lib/utils";

import { badgeVariants } from "./badgeVariants";
import type { BadgeProps } from "./types";

export const CustomBadge = ({
  className,
  variant,
  size,
  children,
  ...props
}: BadgeProps) => {
  return (
    <span
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    >
      {children}
    </span>
  );
};
